module.exports = __webpack_public_path__ + "img/about-history.3f1f4ec2.png";